import { PENDING_TAB_PATH } from "./pending-tab-path";

/**
 * Filled pending (asterisk) icon for selected header navigation tabs.
 * Uses the same path as the outline icon with a thicker white stroke.
 */
const PendingTabFilled = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d={PENDING_TAB_PATH}
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PendingTabFilled;
